import React from 'react';

const SkeletonPropertyDetail = () => {
  return (
    <div className="animate-pulse">
      {/* Image skeleton */}
      <div className="h-96 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200"></div>
      
      <div className="p-8 space-y-6">
        {/* Title and price skeleton */}
        <div className="flex items-center justify-between pb-6 border-b border-gray-200">
          <div className="space-y-3 flex-1">
            <div className="flex gap-2">
              <div className="h-6 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded-full w-24"></div>
              <div className="h-6 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded-full w-20"></div>
            </div>
            <div className="flex gap-6">
              <div className="h-5 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded w-28"></div>
              <div className="h-5 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded w-28"></div>
              <div className="h-5 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded w-28"></div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="h-8 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded w-32"></div>
            <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded w-20"></div>
          </div>
        </div>

        {/* Description skeleton */}
        <div className="space-y-3">
          <div className="h-5 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded w-32"></div>
          <div className="space-y-2">
            <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded w-full"></div>
            <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded w-5/6"></div>
            <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded w-4/6"></div>
          </div>
        </div>

        {/* Amenities skeleton */}
        <div className="space-y-3">
          <div className="h-5 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded w-24"></div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="h-10 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded-lg"></div>
            ))}
          </div>
        </div>

        {/* Location skeleton */}
        <div className="space-y-3">
          <div className="h-5 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded w-24"></div>
          <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded w-64"></div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonPropertyDetail;
